import React, { useRef } from "react";
import { StandaloneSearchBox, LoadScript } from "@react-google-maps/api";
import { ENV } from "../../config/ENV";

const SearchPlaceComponent = (props) => {
  const inputRef = useRef();

  const handlePlaceChanged = () => {
    try {
      const [place] = inputRef.current.getPlaces();
      if (place) {
        let address = {
          street: "",
          area: "",
          city: "",
          state: "",
          zipcode: "",
          country: "",
          latitude: "",
          longitude: "",
        };
        place.address_components.forEach(function (c) {
          switch (c.types[0]) {
            case "route":
              address.street = c.long_name;
              break;
            case "locality":
              address.city = c.long_name;
              break;
            case "neighborhood":
              address.area = c.long_name;
              break;
            case "administrative_area_level_1":
              address.state = c.short_name;
              break;
            case "postal_code":
              address.zipcode = c.long_name;
              break;
            case "country":
              address.country = c.long_name;
              break;
            default:
              break;
          }
        });
        var latitude = place.geometry.location.lat();
        var longitude = place.geometry.location.lng();
        address.latitude = latitude;
        address.longitude = longitude;
        props.parentCallback(address);
      }
    } catch (e) {
      console.log("google map ", e);
    }
  };

  return (
    <LoadScript googleMapsApiKey={ENV.google_api_key} libraries={["places"]}>
      <StandaloneSearchBox
        onLoad={(ref) => (inputRef.current = ref)}
        onPlacesChanged={handlePlaceChanged}
      >
        <input
          type="text"
          data-testid="basicinfo-search"
          className="form-control weeve-font-color t-rounded-lg"
          placeholder="City, State, or Postal Code"
        />
      </StandaloneSearchBox>
    </LoadScript>
  );
};

export default SearchPlaceComponent;
